// AIButton.tsx

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import Loader from 'react-loader-spinner';
import i18n from '../i18n';
import classes from './AIButton.module.css';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface AIButtonProps {
  isContentLoaded: boolean;
  noData: boolean;
  isRequestingAI: boolean;
  handleAIRequest: () => void;
}

const AIButton: React.FC<AIButtonProps> = ({
  isContentLoaded,
  noData,
  isRequestingAI,
  handleAIRequest,
}) => {
  return (
    <>
      {isContentLoaded && !noData && (
        <button
          className={classes.AIButton}
          onClick={handleAIRequest}
          disabled={isRequestingAI}
        >
          <div className={classes.ButtonContent}>
            <div className={classes.IconWrapper}>
              <FontAwesomeIcon icon={faRobot as IconProp} className={classes.Icon} />
              <div className={classes.SpeechBubble}>
                <span className={classes.Dot}></span>
                <span className={classes.Dot}></span>
                <span className={classes.Dot}></span>
              </div>
            </div>
            <span className={classes.ButtonText}>
              {isRequestingAI ? i18n.t('Analyzing') : i18n.t('Analysis')}
            </span>
          </div>
        </button>
      )}

      {isRequestingAI && (
        <div className={classes.ModalOverlay}>
          <div className={classes.ModalContent}>
            <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
            <p>{i18n.t('Analyzing')}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default AIButton;
